import { render } from "./Huisregel.vue?vue&type=template&id=721f3cc1"
import script from "./Huisregel.vue?vue&type=script&lang=js"
export * from "./Huisregel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__